import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useResize from '@/hooks/useResize';
import useCurrentLang from '@/hooks/useCurrentLang';
import {
    PageWrapper,
    BannerWrapper,
    TitleSection,
    MainTitle,
    TabButtonGroup,
    TabButton,
    LinkButton,
    ContentWrapper,
} from './style';
import EHub from './Tabs/eHub';
import DealMakingPortal from './Tabs/dealMakingPortal';
import { Text } from '@/components/UI/Typography/Text';
import { Button } from '@/components/UI/Button';
import { theme } from '@/theme/Theme';
import { Flex } from '@/layout';
import ChinaCompanyCheckList from './Tabs/chinaCompanyCheckList';

const GoGlobalIntroduction = ({ isInsidePage }: { isInsidePage: boolean }) => {
    //   @ts-ignore
    const { t } = useTranslation();
    const { isTablet, isMobile } = useResize();
    const navigate = useNavigate();
    const lang = useCurrentLang();
    const [activeTab, setActiveTab] = useState<'ehub' | 'dealmaking' | 'chinaCompanyCheckList' | 'goglobal'>('ehub');

    return (
        <PageWrapper insidePage={isInsidePage} isTablet={isTablet} isMobile={isMobile}>
            <BannerWrapper isTablet={isTablet} isMobile={isMobile}>
                {
                    lang === 'en' ? (
                        <img src="/images/index/goglobal/banner-en.jpg" alt="GoGlobal Banner" />
                    ) : lang === 'sc' ? (
                        <img src="/images/index/goglobal/banner-sc.jpg" alt="GoGlobal Banner" />
                    ) : (
                        <img src="/images/index/goglobal/banner-tc.jpg" alt="GoGlobal Banner" />
                    )
                }
            </BannerWrapper>

            {/* 標題區域 */}
            <TitleSection isMobile={isMobile} isTablet={isTablet}>
                <MainTitle isMobile={isMobile}>
                    {t('pages.index.GoGlobal.mainTitle')} <br />
                    {t('pages.index.GoGlobal.subTitle')}
                </MainTitle>
            </TitleSection>

            {/* Tab按鈕組 */}
            <TabButtonGroup isMobile={isMobile} isTablet={isTablet}>
                <Button
                    variant={activeTab === 'ehub' ? 'regular' : 'normal'}
                    size="md"
                    onClick={() => setActiveTab('ehub')}
                >
                    {t('pages.index.GoGlobal.tabs.eHub')}
                </Button>
                <Button
                    variant={activeTab === 'dealmaking' ? 'regular' : 'normal'}
                    size="md"
                    onClick={() => setActiveTab('dealmaking')}
                >
                    {t('pages.index.GoGlobal.tabs.dealMaking')}
                </Button>
                <Button
                    variant={activeTab === 'chinaCompanyCheckList' ? 'regular' : 'normal'}
                    size="md"
                    onClick={() => setActiveTab('chinaCompanyCheckList')}
                >
                    {t('pages.index.GoGlobal.tabs.chinaCompanyCheckList')}
                </Button>
                <Button
                    variant={activeTab === 'goglobal' ? 'regular' : 'normal'}
                    size="md"
                    onClick={() => { navigate('/goGlobal') }}
                >
                    {t('pages.index.GoGlobal.tabs.goGlobalIntro')}
                </Button>
            </TabButtonGroup>

            {/* 一站式財務及海專業服務按鈕 */}
            <Flex gridGap={'40px'} justifyContent={'center'} alignItems={'center'} marginBottom={'60px'}>
                <Text fontWeight={'bold'} fontSize={'24px'}>
                    {t('pages.index.GoGlobal.links.financialServices')}
                </Text>
                <Button variant={"primary-invert"} size="md"
                    onClick={() => { navigate('/professionalService?per_page=10&page=1&go_global=1') }}>
                    {t('pages.index.GoGlobal.links.goToMaster')}
                </Button>
            </Flex>

            {/* 內容區域 */}
            <ContentWrapper>
                {activeTab === 'ehub' && <EHub />}
                {activeTab === 'dealmaking' && <DealMakingPortal />}
                {activeTab === 'chinaCompanyCheckList' && <ChinaCompanyCheckList />}
                {activeTab === 'goglobal' && (
                    <div style={{ textAlign: 'center', padding: '50px 0' }}>
                        <p>{t('pages.index.GoGlobal.goGlobalIntro.content')}</p>
                    </div>
                )}
            </ContentWrapper>
        </PageWrapper>
    );
};

export default GoGlobalIntroduction;
